import { useMemo } from 'react';
import useSatellite from './useSatellite';
import useScenario from './useScenario';
import useUrlParams from './useUrlParams';

const useTrueTwin = () => {
    const { selected_satellite, satellites } = useSatellite();
    const { scenario } = useScenario();
    const { sat_id } = useUrlParams();

    const truetwin_id = useMemo(() => {
        // 1. Check selected_satellite
        if (selected_satellite?.value?.trueTwinId) {
            return selected_satellite.value.trueTwinId;
        }

        // 2. Fallback: Search in satellites list
        if (sat_id && satellites) {
            const foundSat = satellites.find(s => s?.value?.satelliteId === sat_id);
            if (foundSat?.value?.trueTwinId) {
                return foundSat.value.trueTwinId;
            }
        }

        // 3. Fallback: Search in scenario satellite groups
        if (sat_id && scenario?.satelliteGroups) {
            for (const group of scenario.satelliteGroups) {
                if (group?.satellites) {
                    const foundSat = group.satellites.find(s => s?.satelliteId === sat_id);
                    if (foundSat?.trueTwinId) {
                        return foundSat.trueTwinId;
                    }
                }
            }
        }

        return undefined;
    }, [selected_satellite, satellites, scenario, sat_id]);

    return { truetwin_id };
};

export default useTrueTwin;